const tributacaoIBSCBS = Object.freeze([
  {
    content: "000 - Tributação integral",
    id: "000 - Tributação integral"
  },
  {
    content: "010 - Tributação com alíquotas uniformes",
    id: "010 - Tributação com alíquotas uniformes"
  },
  {
    content: "011 - Tributação com alíquotas uniformes reduzidas",
    id: "011 - Tributação com alíquotas uniformes reduzidas"
  },
  {
    content: "200 - Alíquota reduzida",
    id: "200 - Alíquota reduzida"
  },
  {
    content: "220 - Alíquota fixa",
    id: "220 - Alíquota fixa"
  },
  {
    content: "221 - Alíquota fixa proporcional",
    id: "221 - Alíquota fixa proporcional"
  },
  {
    content: "222 - Redução de Base de Cálculo",
    id: "222 - Redução de Base de Cálculo"
  },
  {
    content: "400 - Isenção",
    id: "400 - Isenção"
  },
  {
    content: "410 - Imunidade e não incidência",
    id: "410 - Imunidade e não incidência"
  },
  {
    content: "510 - Diferimento",
    id: "510 - Diferimento"
  },
  {
    content: "515 - Diferimento com redução de alíquota",
    id: "515 - Diferimento com redução de alíquota"
  },
  {
    content: "550 - Suspensão",
    id: "550 - Suspensão"
  },
  {
    content: "620 - Tributação Monofásica",
    id: "620 - Tributação Monofásica"
  },
  {
    content: "800 - Transferência de crédito",
    id: "800 - Transferência de crédito"
  },
  {
    content: "810 - Ajuste de IBS na ZFM",
    id: "810 - Ajuste de IBS na ZFM"
  },
  {
    content: "811 - Ajustes",
    id: "811 - Ajustes"
  },
  {
    content: "820 - Tributação em documento específico",
    id: "820 - Tributação em documento específico"
  },
  {
    content: "830 - Exclusão da Base de Cálculo",
    id: "830 - Exclusão da Base de Cálculo"
  }
]);

export default tributacaoIBSCBS;
